import { useAppDispatch, useAppSelector } from '@/globalStore/hooks.ts'
import { useCallback } from 'react'
import { uninstallAppActions } from '@/modules/utilities/uninstallApp/store/uninstallAppSlice/UninstallAppSlice.ts'

const useUninstallApp = () => {
  const dispatch = useAppDispatch()
  const isModalOpen = useAppSelector((state) => state.uninstallApp.modalOpen)

  const closeModal = useCallback(() => {
    dispatch(uninstallAppActions.closeModal())
  }, [dispatch])

  const openModal = useCallback(() => {
    dispatch(uninstallAppActions.openModal())
  }, [dispatch])

  return {
    closeModal,
    openModal,
    isOpen: isModalOpen
  }
}

export default useUninstallApp
